import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Message} from "primeng/api";
import {IFlow} from "../../../../../data/interfaces/iflow.interface";
import {ApiFlowDataService} from "../../../../../data/services/api/flow/api-flow-data.service";
import * as CapacitorCore from "@capacitor/core";
import * as CapacitorBrowser from "@capacitor/browser";
import {LoaderService} from "../../data/services/page/loader.service";

@Component({
  selector: 'app-sign-document',
  templateUrl: './sign-document.component.html',
  styleUrls: ['./sign-document.component.scss']
})
export class SignDocumentComponent implements OnInit{
  responseMessage: Message[] = []
  showMessage = false
  startButtonIsAvailable = false
  @Input() data!: IFlow
  @Output() onEndProcess = new EventEmitter()
  currentUrl = ''
  startedProcess = false

  constructor(
    private flowDataService: ApiFlowDataService,
    private loaderService: LoaderService
  ) {
  }

  async ngOnInit() {
    this.getUrl()
  }

  getUrl() {
    this.loaderService.showSpinner()
    this.flowDataService.getWeetrustDocument({idDocument: this.data.id, idStage: this.data.userDocumentId}).subscribe(r => {
      console.log(r)
      this.loaderService.hideSpinner()
      if (!r.error) {
        if (r.data.status === 'COMPLETED') this.onEndProcess.emit(true)
        this.data.userDocumentId = r.data.stageId
        this.currentUrl = r.data.weetrustDocument.responseData.signatory[0].signing.url
        this.startButtonIsAvailable = true
      } else {
        this.responseMessage = [
          {
            summary: r.msg,
            severity: r.error ?  'error': 'success',
            closable: false,
          }
        ]
      }
    })
  }

  closeWindows(w: Window, url: any) {
    this.flowDataService.getWeetrustDocument({idDocument: this.data.id, idStage: this.data.userDocumentId}).subscribe(r => {

      if (!r.error && r.data.status === 'COMPLETED') {
        w.close()
        clearInterval(url)
        console.log("completed")
      } else {
        console.log("not completed")
      }
    })
  }

  async openIneValidationUrl(url: string) {
    if (CapacitorCore.Capacitor.getPlatform() === 'web') {
      const incodeWindow = open(
        url,
        'user-validation',
        'width=550,height=700,status=0,toolbar=0'
      );
      if (incodeWindow) {
        const detectsUrl = setInterval( (a  = this) => {
          console.log("calling")
          a.closeWindows(incodeWindow, detectsUrl)
        }, 5000);
      }

    } else {
      await CapacitorBrowser.Browser.open({url})
      /*await CapacitorBrowser.Browser.close().then(r => {
        console.log("url closed")
      })*/
    }
  }

  async start() {
    await this.openIneValidationUrl(this.currentUrl)
    setTimeout(( ) => {
      this.startedProcess = true
    }, 2000)

  }
  validateUserSign() {
    console.log("validating")
    this.loaderService.showSpinner()
    setTimeout(() => {
      this.flowDataService.getWeetrustDocument({idDocument: this.data.id, idStage: this.data.userDocumentId}).subscribe(r => {
        this.loaderService.hideSpinner()
        this.responseMessage = [
          {
            summary: r.msg,
            severity: r.error ?  'error': 'success',
            closable: false,
          }
        ]
        if (!r.error) {
          setTimeout(() => {
            this.onEndProcess.emit(true)
          }, 2000)
        }
      })
    }, 5000)

  }
}
